module.exports = __webpack_public_path__ + "static/media/loginbg.72e1e2a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loginbg.png
// module id = 1028
// module chunks = 144